import { all } from 'redux-saga/effects';
import sagaFetchDiyData from './diySaga';
import sagaFetchFundDetails from './fundDetailsSaga';
import mfOrdersSaga from './mfOrdersSaga';
import nomineeSaga from './nomineeSaga';
import referAndEarnSaga from './referAndEarnSaga';
import appSaga from './appSaga';
import portfolioV2Saga from './portfolioV2Saga';
import accountClosureSaga from './accountClosureSaga';
import helpAndSupportSaga from './helpAndSupportSaga';
import scripDetailSaga from './scripDetailSaga';
import sagaFetchMyAccount from './myAccountSaga';
import handleOrdersAuthSaga from './ordersAuthSaga';
import mfV2Saga from './mfV2Saga';
import foDisclosureSaga from './foDisclosureSaga';
import orderFormSaga from './equitySaga/orderFormSaga';
import orderBookSaga from './equitySaga/orderBookSaga';
import stocksPortfolioSaga from './equitySaga/stocksPortfolioSaga';
import watchlistSaga from './equitySaga/watchlistSaga';
import indicesSaga from './equitySaga/indicesSaga';
import marketWatchSaga from './equitySaga/marketWatchSaga';
import stockNewsSaga from './landing/stockLanding/stockNewsSaga';
import newsAndAnnouncementsSaga from './equitySaga/newsAndAnnouncementsSaga';
import guestLoginSaga from './guestLoginSagaV2';
import optionChainSaga from './optionChainSaga.js';
import addFundsSaga from './paymentV2Saga/addFundsSaga';
import mfPaymentSaga from './paymentV2Saga/mfSaga';
import paymentCommonSaga from './paymentV2Saga';
import tradeSocketListenerSaga from "./equitySaga/tradeSocketListenerSaga";
import fetchMostBoughtSaga from './equitySaga/mostBoughtStocksSaga';
import fundsSaga from './equitySaga/fundsSaga';
export default function* rootSaga() {
	yield all([
		sagaFetchFundDetails(),
		sagaFetchDiyData(),
		mfOrdersSaga(),
		nomineeSaga(),
		referAndEarnSaga(),
		appSaga(),
		portfolioV2Saga(),
		accountClosureSaga(),
		helpAndSupportSaga(),
		sagaFetchMyAccount(),
		handleOrdersAuthSaga(),
		mfV2Saga(),
		foDisclosureSaga(),
		orderFormSaga(),
		orderBookSaga(),
		stocksPortfolioSaga(),
		scripDetailSaga(),
		watchlistSaga(),
		indicesSaga(),
		marketWatchSaga(),
		stockNewsSaga(),
		newsAndAnnouncementsSaga(),
		guestLoginSaga(),
		optionChainSaga(),
		addFundsSaga(),
		paymentCommonSaga(),
		mfPaymentSaga(),
		fundsSaga(),
		tradeSocketListenerSaga(),
		fetchMostBoughtSaga()
	]);
}
